/**
 * Time windows configuration
 *
 * - GLOBAL_THROTTLE: 15 minutes - prevents showing spotlight within 15 minutes of last shown
 * - STAGE_1_TO_2: 7 days - after first nudge, wait 7 days before showing second
 * - STAGE_2_TO_3: 30 days - after second nudge, wait 30 days before showing third
 * - STAGE_3_PLUS: 90 days - after third+ nudge, wait 90 days before showing again
 */
export const TIME_WINDOWS: {
	GLOBAL_THROTTLE: number;
	STAGE_1_TO_2: number;
	STAGE_2_TO_3: number;
	STAGE_3_PLUS: number;
} = {
	GLOBAL_THROTTLE: 15 * 60 * 1000, // 15 minutes
	STAGE_1_TO_2: 7 * 24 * 60 * 60 * 1000, // 7 days
	STAGE_2_TO_3: 30 * 24 * 60 * 60 * 1000, // 30 days
	STAGE_3_PLUS: 90 * 24 * 60 * 60 * 1000, // 90 days
};
